var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20C18.6562 20 20 21.3438 20 23C20 24.6875 18.6562 26 17 26C15.3125 26 14 24.6875 14 23V20C14 17.8125 15.7812 16 18 16C18.5312 16 19 16.4688 19 17C19 17.5625 18.5312 18 18 18C16.875 18 16 18.9062 16 20V20.1875C16.3125 20.0938 16.625 20 17 20ZM25 20C26.6562 20 28 21.3438 28 23C28 24.6875 26.6562 26 25 26C23.3125 26 22 24.6875 22 23V20C22 17.8125 23.7812 16 26 16C26.5312 16 27 16.4688 27 17C27 17.5625 26.5312 18 26 18C24.875 18 24 18.9062 24 20V20.1875C24.3125 20.0938 24.625 20 25 20Z",
    fill: "#5F6774"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledQuote);
export default __webpack_public_path__ + "static/media/filledQuote.f12a9045dc5574b68128976481c3a176.svg";
export { ForwardRef as ReactComponent };